import React from "react"

import PropTypes from "prop-types"

import * as styles from "./overlay.module.scss"

const Overlay = ({ label, menu, event, trigger, children }) => (
  <div
    role="button"
    tabIndex="0"
    aria-label={label}
    className={`${styles.overlay} ${menu ? styles.overlay__menu : ""} ${
      trigger ? styles.overlay__open : ""
    }`}
    onClick={event}
    onKeyPress={event}
  >
    {children}
  </div>
)

export default Overlay

Overlay.propTypes = {
  label: PropTypes.string,
  menu: PropTypes.bool,
  trigger: PropTypes.bool.isRequired,
  event: PropTypes.func.isRequired,
  children: PropTypes.node,
}

Overlay.defaultProps = {
  label: "",
  menu: false,
  children: null,
}
